import React from "react";
import LineCrudTableRowModal2 from "./LineCrudTableRowModal2";

const LineCrudTableModal2 = ({ListClientsWhitLine,desvinculedClient}) => {
    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Cliente Vinculado:</h6>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{border:'1px solid black'}}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" className="text-center">Nombres</th>
                            <th scope="col" className="text-center">Apellidos</th>
                            <th scope="col" className="text-center">Número de Documento</th>
                            <th scope="col" className="text-center">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        ListClientsWhitLine.length > 0 ? ListClientsWhitLine.map((el, i) => <LineCrudTableRowModal2 key={el._id} el={el} i={i} desvinculedClient={desvinculedClient}/>) :
                            <tr>
                                <td colSpan="5">Sin datos</td>
                            </tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default LineCrudTableModal2;
